import React, { useState } from 'react'
import ReportsApi from '../../../../api/ReportsApi'
import PieChart from 'components/PieChart/PieChart'
import { IReportFilter } from 'views/Reports'
import { AccentArea } from 'components'

// Define the interface for the API response data
interface ReasonCodeData {
    count: number;
    pct: number;
    description: string;
    name: string;
    code: string;
    value?: number; // For PieChart compatibility
    tooltipName?: string;
}

/**
 * @name ByReasonCodeDistribution
 * @desc Render Reason Code Distribution
 * @filterValues IReportsFilter
 */
const ByReasonCodeDistribution = ({
    filterValues,
}: {
    filterValues: IReportFilter
}): React.ReactElement => {
    const [loading, setLoading] = useState<boolean>(true)
    const [data, setData] = useState<ReasonCodeData[]>([])

    React.useEffect(() => {
        if(!filterValues.merchant_id) return
        
        setLoading(true)
        ReportsApi.getByReasonCode(filterValues, true).then((apiData: ReasonCodeData[]) => {
            setLoading(false)
            // Filter out the "Others" object from the dataset
            const filteredData = apiData.filter((item: ReasonCodeData) => item.name !== "Others")
            setData(filteredData)
        })
    }, [filterValues]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <AccentArea title="Reason Code Distribution (Top 5)">
            <PieChart
                data={data}
                loading={loading}
                testId="byReasonCodeDistribution"
                height={350}
                pieLabelLayout={'inside'}
            />
        </AccentArea>
    )
}

export default ByReasonCodeDistribution
